import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LogoutOutlined, UserOutlined, CopyrightOutlined, FullscreenOutlined, FullscreenExitOutlined, SyncOutlined } from '@ant-design/icons';
import { Layout, Menu, theme, Dropdown, Avatar, Breadcrumb, Button, Flex, message } from 'antd';
import { Resizable } from 're-resizable';
import { AppRoutes } from '../../Routes/Routes';
import { useSidebarContext } from '@/@crema/utility/AppContextProvider/SidebarContextProvider';
import { MenuStyle } from '@/../src/shared/constants/AppEnums';
import defaultConfig from '@/@crema/utility/AppContextProvider/defaultConfig';
import clsx from 'clsx';
import '@/@crema/core/AppLayout/components/AppVerticalNav/index.style.less';
import { DownOutlined, AppstoreOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import {
  setCompany,
  setFinyear,
  logoutUser,
  getLatestAuth,
  getEwayBillRechargedCustomers,
  getAuthFinyearsCompanies,
  setResetLoadMasterOption,
  setResetLoadSettingsOption
} from '@/redux/actions';
import { DraftMenuProvider, useGetSidebarMenu } from './menus';
import profita_logo from '@/assets/images/profita_logo.png';
import SubHeader from './SubHeader';
import { CommonCall } from './commonCall';
import { GlobalKeyDown } from './GlobalKeyDown';
import { useModulePermissions } from '../../PermissionsContext/usePermissionHook';
import { MODULE_IDS } from '../../PermissionsContext/moduleConstants';
import KeyBoardShortCut  from './KeyboradShortCut';
import { dateFormat } from '@/utils';
import dayjs from '@/utils/dayjs';
import * as _ from 'lodash';
import '../styles/layout.css';

const { Header, Content, Sider } = Layout;

const LayoutComponentInner = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  // const { sidebarColorSet} = useSidebarContext();
  // const {themeMode} = useThemeContext() || {};
  const {menuStyle, sidebarColorSet, isSidebarBgImage, sidebarBgImage} = useSidebarContext() || {};
  const [collapsed, setCollapsed] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [userItems, setUserItems] = useState([]);
  const [finyearItems, setFinyearItems] = useState([]);
  const [sideWidth, setSideWidth] = useState('80px');
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [finyears, setFinyears] = useState([]);
  const [companyArray, setCompanyArray] = useState([]);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { user, company, finyear, superUser, customer, token } = useSelector((state) => state?.auth);
  const selectedKeys = pathname.substr(1).split('/');
  const [messageApi, contextHolder] = message.useMessage();
  const { menu, superMenu } = useGetSidebarMenu(null, messageApi);
  const { customers = [], loading } = useSelector((state) => state?.ewayBillRecharge);
  const [ ewayBillCredits , setEwayBillCredits ] = useState({});
  const [showSubHeader, setShowSubHeader] = useState(true);
  const permissions = useModulePermissions(MODULE_IDS.COMPANY);

  useLayoutEffect(() => {
    // Sync state when fullscreen changes (ESC or browser buttons)
    const handleChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    handleChange();
    document.addEventListener("fullscreenchange", handleChange);
    return () => document.removeEventListener("fullscreenchange", handleChange);
  }, []);

  useEffect(() => {
    if (customer?.id && token) {
      dispatch(getEwayBillRechargedCustomers());
    }
  }, [`${customer?.id}-${token}`]);

  // Once customers are loaded, find the matching one and set credits
  useEffect(() => {
    if (customer?.id && customers.length > 0) {
      const matchedCustomer = customers.find(c => c.id === customer.id);
      if (matchedCustomer) {
        setEwayBillCredits(matchedCustomer); // or pick specific fields if needed
      } else {
        setEwayBillCredits({}); // fallback if not found
      }
    }
  }, [customer, customers]);

  useEffect(() => {
    dispatch(getLatestAuth());
  }, []);

  const formatTitle = (segment) => {
    return segment
      .replace(/-/g, ' ') // Replace dashes with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  };
  
  const DynamicBreadcrumb = () => {
    const location = useLocation();
    const pathSnippets = location.pathname.split('/').filter((i) => i);
    const breadcrumbItems = pathSnippets.map((data) => ({ title: formatTitle(data) }));
    return <Breadcrumb items={breadcrumbItems}/>;
  };

  
  useLayoutEffect(() => {
    setTimeout(() => {
      const headerHeight = document.getElementById('root-header')?.offsetHeight;
      const layout = document.getElementById('root-layout');
      const sidebar = document.getElementById('root-sidebar');
      const sidebarTrigger = document.getElementsByClassName('ant-layout-sider-trigger');
      if (layout) {
        layout.style.maxHeight = `calc(100vh - ${headerHeight + (showSubHeader ? 0 : 10)}px)`;
      }
      if (sidebar && sidebarTrigger?.length) {
        const triggerHeight = sidebarTrigger[0]?.offsetHeight;
        sidebar.style.height = `calc(100vh - ${headerHeight + triggerHeight}px)`;
      }
    }, 700);
  }, [document.getElementById('root-header')?.offsetHeight, showSubHeader]);

  useLayoutEffect(() => {
    const sidebarTrigger = document.getElementsByClassName('ant-layout-sider-trigger')[0];
    if (sidebarTrigger) {
      sidebarTrigger.style.width = sideWidth;
    }
  }, [sideWidth]);

  useEffect(() => {
    if (token && customer?.id) {
      dispatch(getAuthFinyearsCompanies())
      .then((res) => {
        setFinyears(res?.finyears || []);
        setCompanyArray(res?.companies || []);
      }).catch((e) => {
        setFinyears([]);
        setCompanyArray([]);
      });
    }
  }, [`${token}-${customer?.id}`]);

  useEffect(() => {
    setFinyearItems(
      (finyears || []).map((finyear) => ({
          key: finyear.id,
          label: (<div>{`${dayjs(finyear.From_Date).format('YYYY')} - ${dayjs(finyear.To_Date).format('YYYY')}`}</div>),
      }))
    );
  }, [finyears])

  useEffect(() => {
    setCompanies(
      (companyArray)
      .filter((comp) => comp.Finyear_Ids.includes(finyear?.id))
      .map((data) => ({
        key: data.id,
        label: (<div>{data.Company_Name}</div>),
      }))
    );
  }, [companyArray, finyear?.id]);

  useEffect(() => {
    const onClickSignOut = () => {
      dispatch(logoutUser());
      dispatch(setResetLoadMasterOption());
      dispatch(setResetLoadSettingsOption());
      navigate('/');
    }

    const items = [
      {
        key: 'user',
        label: (
          <div className='user-wrapper'>
            <Avatar size="large" className='avtarBG' icon={<UserOutlined />} style={{ color:'black' }}/>
            <div className='user ml-10'>
              <div className='font-bold'>{(user || superUser)?.Username}</div>
              <div className='email'>{(user || superUser)?.Email}</div>
              {customer?.id ? <div className='email'>({customer?.C_Id})</div> : null}
            </div>
          </div>
        ),
      },
      {
        type: 'divider',
      },
      {
        key: 'logout',
        label: (
          <div className='user-wrapper' onClick={onClickSignOut}>
            <LogoutOutlined className='sign-out' />
            <div>Sign Out</div>
          </div>
        ) 
      }      
    ];

    if (permissions.canVisible()) {
      items.splice(2, 0,
        {
          key: 'company',
          label: (
            <div
              className='user-wrapper'
              onClick={() => {navigate('/masters/company')}}
            >
              <CopyrightOutlined className='sign-out'/>
              <div>Company</div>
            </div>
          ) 
        },
        {
          type: 'divider',
        },
        {
          key: 'refresh',
          label: (
            <div
              className='user-wrapper'
              onClick={() => {
                dispatch(setResetLoadMasterOption());
                dispatch(setResetLoadSettingsOption());
              }}
            >
              <SyncOutlined className='sign-out'/>
              <div>Referesh Accounts/Items</div>
            </div>
          ) 
        },
        {
          type: 'divider',
        }
      );
    }
    setUserItems(items);
  }, [user, superUser, JSON.stringify(permissions?.modulePermissions)]);

  const handleToggle = () => {
    console.log('showSubHeader:', collapsed, showSubHeader);
    if (collapsed) {
      // Sidebar is collapsed → open it, close subheader
      setCollapsed(false);
      setShowSubHeader(false);
    } else
    if (showSubHeader) {
      // Subheader is open → close it, open sidebar
      setShowSubHeader(false);
      setCollapsed(false);
    } else {
      // Default → open subheader, close sidebar
      setShowSubHeader(true);
      setCollapsed(true);
    }
  };

  const onCollapse = (collapsed, rest) => {
    setCollapsed(collapsed);
    if (!collapsed) {
      setSideWidth('200px');
    }
  };

  const handleMenuClick = ({ keyPath }) => {
    const path = keyPath.reverse().join('/');
    navigate(`/${path}`);
  };

  const onResize = (e, direction, ref, d) => {
    const currentWidth = ref.style.width;
    if (currentWidth === '80px') {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
    setSideWidth(currentWidth);
  };

  const onClickCompany = (item) => {
    const selectedComp = companyArray.find((data) => parseInt(data.id) === parseInt(item.key));
    dispatch(setResetLoadMasterOption());
    dispatch(setResetLoadSettingsOption());
    dispatch(setCompany(selectedComp));
  }

  const onClickFinyear = (item) => {
    const selectedYear = finyears.find((data) => parseInt(data.id) === parseInt(item.key));

    dispatch(setFinyear(selectedYear));
    const companies = companyArray?.filter((data) => data.Finyear_Ids.includes(selectedYear?.id)).map((val) => val.id) || [];

    if (!companies.includes(company?.id)) {
      dispatch(setCompany(null));
    }
  }

  const onClickUser = (item) => {
    if (item.key === 'logout') {
      dispatch(logoutUser());
      navigate('/');
    }
  }

  const toggleFullscreen = () => {
    const fullscreen = document.fullscreenElement;
    console.log('<<full screen--', fullscreen);
    if (!fullscreen) {
      // Enter fullscreen
      document.documentElement.requestFullscreen();
    } else {
      // Exit fullscreen
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    }
    setIsFullscreen(!isFullscreen);
  };

  return (pathname === '/login' || pathname === '/404' || pathname === '/privacy-policy') ? (
    <Layout id={'root-layout'} className='layout'>
      <AppRoutes/>
    </Layout>
  ) : (
    <Layout className='layout'>
      {contextHolder}
      <CommonCall/>
      <GlobalKeyDown/>
      <Header
        id={'root-header'}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: '#ffffff', // Primary Ant Design color
          padding: '0 20px',
          height: '64px',
          border: 'none', 
          borderBottom: '1px solid  rgb(0 0 0 / 33%)',                      
        }}
      >
        {/* Center Items */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <>
              {/* Logo Section */}
              <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                >
                  <div
                    style={{
                      width: '150px',
                      maxHeight: '55px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      src={profita_logo}
                      alt="Logo"
                      style={{
                        width: '126px',
                        objectFit: 'contain',
                      }}
                      onClick={() => navigate('/dashboard')}
                    />
                  </div>
              </div>
              <Button
                type="text"
                // icon={showSubHeader ? <MenuFoldOutlined /> : collapsed ? <MenuUnfoldOutlined /> : <AppstoreOutlined />}
                onClick={handleToggle}
                style={{ fontSize: '15px' }}
              >
                {showSubHeader ? <MenuFoldOutlined /> : collapsed ? <MenuUnfoldOutlined /> : <AppstoreOutlined />}
              </Button>
            </>

        {user && (
          <>
            {/* Company Dropdown */}
            <Dropdown menu={{ items: companies, onClick: onClickCompany }}>
              <div style={{ marginRight: '16px', color: '#000', cursor: 'pointer' }}>
                <span style={{
                  padding: '12px 24px',
                  marginLeft: '20px',
                  color: '#000000E0',
                  fontWeight: '500',
                  listStyleType: 'none',
                  borderRadius: '8px',
                  backgroundColor: '#ffffff',
                  backgroundClip: 'padding-box',
                  outline: 'none',
                  boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
                }}> 
                {company?.Company_Name || 'Select Company'} <DownOutlined />
                </span>
              </div>
            </Dropdown>

            <div>
              {/* Financial Year Dropdown */}
              <Dropdown menu={{ items: finyearItems, onClick: onClickFinyear }}>
                <div style={{ color: '#000', cursor: 'pointer' }}>
                  <span
                    style={{
                      padding: '12px 24px',
                      color: '#000000E0',
                      fontWeight: '500',
                      listStyleType: 'none',
                      backgroundColor: '#ffffff',
                      backgroundClip: 'padding-box',
                      borderRadius: '8px',
                      outline: 'none',
                      boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
                    }}
                  >
                    {finyear
                      ? `${dayjs(finyear?.From_Date).format('YYYY')} - ${dayjs(finyear?.To_Date).format('YYYY')}`
                      : 'Select Financial Year'}{' '}
                    <DownOutlined />
                  </span>
                </div>
              </Dropdown>
            </div>
            <div className='finyear-date'>
              {`${dayjs(finyear?.From_Date).format(dateFormat)} - ${dayjs(finyear?.To_Date).format(dateFormat)}`}
            </div>

            { ewayBillCredits && ewayBillCredits?.currentBalance <= 50 && (
              <span className="text-warning-animate" style={{ marginLeft: '16px', fontWeight: '500' }}>
                ⚠️ You have {' '}
                <span >
                  {ewayBillCredits?.currentBalance || 0}
                </span> {' '}
                Eway Bill Credits remaining
              </span>
            )}
          </>
        )}
        </div>
        
        {/* User Section */}
        <Flex gap={'large'}>
          {customer?.id ? <div className='customer-id-title'>{`Customer Id : ${customer?.C_Id || ''}`}</div> : null}
          <Button
            style={{ margin: 'auto' }}
            icon={isFullscreen ? <FullscreenExitOutlined style={{ fontSize: '20px' }}/> : <FullscreenOutlined style={{ fontSize: '20px' }}/>}
            onClick={toggleFullscreen}
          />
          {/* <KeyBoardShortCut /> */}
          <div>
            <Dropdown menu={{ items: userItems, onClick: onClickUser }}>
              <Avatar
                size="large"
                style={{
                  backgroundColor: '#F4F7FE',
                  cursor: 'pointer',
                  color: 'black',
                  fontWeight: '500',
                }}
              >
                {(user || superUser)?.Username[0]?.toUpperCase()}
              </Avatar>
            </Dropdown>
          </div>
        </Flex>
      </Header>
      <Layout>
        {!showSubHeader && ( 
        <Resizable
          size={collapsed ? 90 : sideWidth}
          defaultSize={sideWidth}
          onResize={onResize}
          maxWidth={700}
          minWidth={90}
          enable={{ right: true }}
          handleStyles={{
            right: {
              width: '8px',
              cursor: 'ew-resize',
              position: 'absolute',
              right: 0,
              top: 0,
              bottom: 0,
              zIndex: 10,
              transition: 'all 0.3s ease', // Smooth transition for resizing
            },
          }}
        >
          <div>
            <Sider
              id={'root-sidebar'}
              theme='light'
              breakpoint="lg"
              className={clsx('app-DrawerLayout-sidebar', {
                'drawerLayout-sidebar-img-background': isSidebarBgImage ? `url(/assets/images/sidebar/images/${sidebarBgImage}.png)` : '',
              })}
              style={{
                backgroundColor: sidebarColorSet?.sidebarBgColor || '#ffffff',
                color: sidebarColorSet?.sidebarTextColor || '#333333',
                backgroundImage: isSidebarBgImage
                  ? `url(/assets/images/sidebar/images/${sidebarBgImage}.png)`
                  : '',
                borderRight: `1px solid ${sidebarColorSet?.borderColor || '#e0e0e0'}`, // Lighter border for a softer look
                boxShadow: '25px 29px 85px -82px rgba(0, 0, 0, 0.75)', // Adding subtle shadow for depth
                transition: 'all 0.3s ease', // Smooth transition for background change
              }}
              collapsible={true}
              collapsed={collapsed}
              onCollapse={onCollapse}
            >
              <Menu
                theme='light'
                mode="inline"
                className={clsx('app-main-sidebar-menu', {
                  'menu-rounded': menuStyle === MenuStyle.ROUNDED,
                  'menu-rounded rounded-menu-reverse': menuStyle === MenuStyle.ROUNDED_REVERSE,
                  'menu-rounded standard-menu': menuStyle === MenuStyle.STANDARD,
                  'menu-rounded curved-menu': menuStyle === MenuStyle.CURVED_MENU,
                  'bg-color-menu': sidebarColorSet?.sidebarBgColor !== (defaultConfig?.sidebar?.colorSet?.sidebarBgColor || '#ffffff'),
                })}
                selectedKeys={[selectedKeys[selectedKeys.length - 1]]}
                defaultSelectedKeys={['dashboard']}
                defaultOpenKeys={['dashboard']}
                items={user?.id ? menu : superUser?.id ? superMenu : []}
                onClick={handleMenuClick}
                style={{
                  paddingTop: '5px', // Increased padding for cleaner look
                  paddingBottom: '5px', // More consistent spacing
                  // height: '100%', 
                }}
              />
            </Sider>
            
          </div>
        </Resizable>
        )}
  
        <Layout id={'root-layout'}  style={{ backgroundColor: '#f4f7fe', height: 'inherit', overflow: 'auto' }}>
              {showSubHeader && <SubHeader/>}
              <Content
                id={'root-layout-content'}
                className='layout-content'
                style={{
                  background: colorBgContainer,
                  borderRadius: borderRadiusLG,
                  backgroundColor: '#f4f7ff',
                }}
              >
                {/* <DynamicBreadcrumb /> */}
                <AppRoutes/>
              </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

const LayoutComponent = () => (
  <DraftMenuProvider>
    <LayoutComponentInner />
  </DraftMenuProvider>
);

export default LayoutComponent;